import { AnimatePresence, LayoutGroup, motion } from "framer-motion";
import { useContext, useEffect, useRef, useState } from "react";

import { BiSolidCategory } from "react-icons/bi";
import { DataContext } from "../../Context/DataContext/DataContext";
import DataLoading from "../../Suspense/Loadings/DataLoading/DataLoading";
import { FaBorderAll } from "react-icons/fa6";
import { IoCall } from "react-icons/io5";
import { IoIosArrowBack } from "react-icons/io";
import { Link } from "react-router-dom";
import MobileSearch from "../../ClientSearch/Products/MobileSearch/MobileSearch";
import { TbHomeFilled } from "react-icons/tb";
import logo from "../../Assets/Images/Logo/LogoGreen.png";

const MobileNav = ({ selectedMenu, setSelectedMenu }) => {
  const navRef = useRef(null);
  const menuButtonRef = useRef(null);
  const [toggleNav, setToggleNav] = useState(false);
  const { categories, categoriesLoading } = useContext(DataContext);
  const [showSubMenu, setShowSubMenu] = useState(false);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        navRef.current &&
        !navRef.current.contains(e.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(e.target)
      ) {
        setToggleNav(false);
        setShowSubMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggleNav = () => {
    setToggleNav(!toggleNav);
    setShowSubMenu(false);
  };

  const menuVars = {
    initial: { opacity: 1, width: 0 },
    animate: {
      opacity: 1,
      width: "18rem",
      transition: {
        duration: 0.7,
      },
    },
    exit: {
      opacity: 1,
      width: 0,
      transition: {
        duration: 0.7,
        delay: 0.2,
      },
    },
  };
  return (
    <div className="md:hidden">
      {/* Start-menuButton */}
      <motion.button
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.9 }}
        transition={{
          type: "spring",
          stiffness: 400,
          damping: 17,
        }}
        ref={menuButtonRef}
        onClick={handleToggleNav}
        className={`md:hidden flex flex-col items-center justify-center space-y-1 z-50 ${
          toggleNav ? "fixed top-[1.9rem] right-[2rem]" : "sticky"
        }`}
        // z-index doesn't work on static positions
        animate={toggleNav ? "open" : "closed"}
      >
        <motion.span
          className={`h-[0.10rem] w-7 rounded-2xl bg-yellow-600 shadow-lg shadow-white relative ${
            toggleNav && "bg-yellow-700"
          }`}
          variants={{
            closed: { opacity: 1, rotate: "0deg" },
            open: { opacity: 1, rotate: "-45deg", y: 5 },
          }}
        ></motion.span>
        <motion.span
          className={`h-[0.10rem] w-7 rounded-2xl bg-yellow-600 shadow-lg shadow-white ${
            toggleNav && "bg-yellow-700"
          }`}
          variants={{
            closed: { opacity: 1, rotate: "0deg", y: 0 },
            open: { opacity: 1, rotate: "45deg", y: 0 },
          }}
        ></motion.span>
        <motion.span
          className={`h-[0.10rem] w-7 rounded-2xl bg-yellow-600 shadow-lg shadow-white ${
            toggleNav && "bg-yellow-700"
          }`}
          variants={{
            closed: { opacity: 1, rotate: "0deg" },
            open: { opacity: 0 },
          }}
        ></motion.span>
      </motion.button>
      {/* End-menuButton */}
      <AnimatePresence mode="wait">
        {toggleNav && (
          <motion.div dir="rtl" className="z-50" ref={navRef}>
            <motion.div
              variants={menuVars}
              initial="initial"
              animate="animate"
              exit="exit"
              className="fixed z-40 right-0 top-0 h-screen w-[18rem] bg-[#E1D7B7]/70 
              flex items-center justify-start flex-col md:hidden backdrop-blur-md 
              border-l-2 border-yellow-600"
            >
              <motion.div
                layout
                className="flex flex-col items-center justify-start w-full overflow
                gap-9 relative px-2  pt-10"
              >
                {/* Start-logo */}
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{
                    duration: 0.5,
                    delay: 0.2,
                  }}
                  className="flex items-center justify-center cursor-pointer overflow-hidden 
                  group relative p-2"
                >
                  <Link
                    to="/"
                    onClick={() => {
                      setToggleNav(false);
                    }}
                  >
                    <motion.div
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      transition={{
                        type: "spring",
                        damping: "17",
                        stiffness: "400",
                      }}
                      className="w-[6rem] h-[6rem]"
                    >
                      <img
                        src={logo}
                        alt="logo"
                        className="w-full h-full object-contain"
                      />
                    </motion.div>
                  </Link>
                </motion.div>
                {/* End-logo */}

                {/* menu items */}
                {/* Start-Home */}
                <LayoutGroup>
                  <motion.div layout className="overflow-hidden">
                    <motion.div
                      initial={{ y: 50 }}
                      animate={{ y: 0 }}
                      exit={{ y: 50 }}
                      transition={{ duration: 0.5 }}
                    >
                      <motion.div
                        className="relative group flex items-center justify-center overflow-hidden 
                    h-full transition-all"
                      >
                        <Link
                          onClick={() => {
                            setSelectedMenu("home");
                            setToggleNav(false);
                          }}
                          to="/"
                          className={`flex items-center justify-center gap-1 px-2 
                      ease-in-out duration-100 h-full py-4 ${
                        selectedMenu === "home"
                          ? "-translate-y-2 py-4 text-yellow-700"
                          : "group-hover:-translate-y-2 group-hover:py-4 text-black group-hover:text-yellow-700"
                      }`}
                        >
                          <p dir="rtl" className="font-tajawal">
                            الرئيسيه
                          </p>
                          <TbHomeFilled />
                        </Link>
                        <span
                          className={`ease-in-out absolute bottom-0 h-2 rounded-t-full bg-yellow-700
                      duration-100 flex items-center justify-center ${
                        selectedMenu === "home"
                          ? "w-full"
                          : "group-hover:w-full w-0"
                      }`}
                        ></span>
                      </motion.div>
                    </motion.div>
                  </motion.div>
                  {/* End-Home */}
                  {/* Start-categories */}
                  <div className="overflow-hidden hover:overflow-visible flex relative items-center justify-center">
                    <motion.div
                      initial={{ y: 50 }}
                      animate={{ y: 0 }}
                      exit={{ y: 50 }}
                      transition={{ duration: 0.5, delay: 0.1 }}
                      className="flex items-center justify-center relative"
                    >
                      <motion.div
                        className=" flex items-center justify-center 
                    overflow h-full transition-all px-2 group"
                        dir="rtl"
                      >
                        <Link
                          to="/categories"
                          onClick={() => setToggleNav(false)}
                          className={`flex items-center justify-center gap-1 px-2 
                      ease-in-out duration-100 h-full py-4 ${
                        selectedMenu === "categories"
                          ? "-translate-y-2 py-4 text-yellow-700"
                          : "group-hover:-translate-y-2 group-hover:py-4 text-black group-hover:text-yellow-700"
                      }`}
                        >
                          <p dir="rtl" className="font-tajawal">
                            التصنيفات
                          </p>
                          <BiSolidCategory />
                        </Link>
                        <span
                          className={`ease-in-out absolute bottom-0 h-2 rounded-t-full bg-yellow-700
                      duration-100 flex items-center justify-center ${
                        selectedMenu === "categories"
                          ? "w-full"
                          : "group-hover:w-full w-0 "
                      }`}
                        ></span>
                      </motion.div>
                    </motion.div>
                    <motion.div
                      initial={{ y: 60 }}
                      animate={{ y: 0 }}
                      exit={{ y: 60 }}
                      transition={{ duration: 0.5, delay: 0.1 }}
                      className={`flex items-center justify-center h-full m-1 border-r-2 
                       ${
                         showSubMenu
                           ? "border-yellow-700 text-yellow-700"
                           : "border-white text-black hover:border-yellow-700 hover:text-yellow-700"
                       }`}
                    >
                      <motion.button
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        animate={{ rotate: showSubMenu ? 180 : 0 }}
                        transition={{
                          duration: 0.2,
                        }}
                        className="flex items-center justify-center p-2 w-full h-full"
                        onClick={() => setShowSubMenu(!showSubMenu)}
                      >
                        <IoIosArrowBack />
                      </motion.button>
                    </motion.div>

                    <motion.div
                      initial={{ width: 0, opacity: 0 }}
                      animate={{
                        width: showSubMenu ? "auto" : 0,
                        opacity: showSubMenu ? 1 : 0,
                      }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                      className={` absolute z-20 flex items-center justify-center right-full`}
                    >
                      <motion.div
                        className="flex items-center justify-center flex-col  border-2 
                        bg-[#E1D7B7] rounded-xl border-yellow-600 overflow-hidden 
                        w-[10rem] h-full  text-center"
                      >
                        {categoriesLoading ? (
                          <div classname=" flex items-center justify-center w-full">
                            <DataLoading color="bg-black" />
                          </div>
                        ) : (
                          categories.map((category, index) => (
                            <Link
                              key={index}
                              className="w-full flex items-center justify-center"
                              to={`/categories/${category.category}`}
                              onClick={() => setToggleNav(false)}
                            >
                              <div
                                className={`overflow-hidden w-full flex items-center justify-center ${
                                  index === categories.length - 1
                                    ? "border-b-0"
                                    : "border-b-2"
                                }`}
                              >
                                <motion.div
                                  initial={{ x: 50 , opacity: 0 }}
                                  animate={{
                                    x: showSubMenu ? 0 : 50,
                                    opacity: showSubMenu ? 1 : 0,
                                    transition: {
                                      delay: index * 0.2,
                                      duration: 0.3,
                                      ease: "easeInOut",
                                    },
                                  }}
                                  className="flex items-center justify-center p-2 text-yellow-600 hover:bg-stone-500
                        w-full hover:text-white text-center"
                                >
                                  <p>{category.category}</p>
                                </motion.div>
                              </div>
                            </Link>
                          ))
                        )}
                      </motion.div>
                    </motion.div>
                  </div>
                  {/* End-Categories */}
                  {/* start-allproducts */}
                  <motion.div layout className="overflow-hidden">
                    <motion.div
                      initial={{ y: 80 }}
                      animate={{ y: 0 }}
                      exit={{ y: 90 }}
                      transition={{ duration: 0.5, delay: 0.2 }}
                    >
                      <motion.div
                        className="relative group flex items-center justify-center overflow-hidden 
                    h-full transition-all"
                      >
                        <Link
                          onClick={() => {
                            setSelectedMenu("products");
                            setToggleNav(false);
                          }}
                          to="/products"
                          className={`flex items-center justify-center gap-1 px-2 
                      ease-in-out duration-100 h-full py-4  ${
                        selectedMenu === "products"
                          ? "-translate-y-2 py-4 text-yellow-700"
                          : "group-hover:-translate-y-2 group-hover:py-4 text-black group-hover:text-yellow-700"
                      }`}
                        >
                          <p dir="rtl" className="font-tajawal">
                            جميع المنتجات
                          </p>
                          <FaBorderAll />
                        </Link>
                        <span
                          className={`ease-in-out absolute bottom-0 h-2 rounded-t-full bg-yellow-700
                      duration-100 flex items-center justify-center ${
                        selectedMenu === "products"
                          ? "w-full"
                          : "group-hover:w-full w-0"
                      }`}
                        ></span>
                      </motion.div>
                    </motion.div>
                  </motion.div>
                  {/* start-allproducts */}
                  {/* Start-contactUs */}
                  <motion.div layout className="overflow-hidden">
                    <motion.div
                      initial={{ y: 90 }}
                      animate={{ y: 0 }}
                      exit={{ y: 90 }}
                      transition={{ duration: 0.5, delay: 0.3 }}
                    >
                      <motion.div
                        className="relative group flex items-center justify-center 
                      overflow-hidden h-full transition-all"
                      >
                        <Link
                          to="/contactus"
                          onClick={() => setToggleNav(false)}
                          className={`flex items-center justify-center gap-1 px-2 
                      ease-in-out duration-100 h-full py-4 ${
                        selectedMenu === "contactus"
                          ? "-translate-y-2 py-4 text-yellow-700"
                          : "group-hover:-translate-y-2 group-hover:py-4 text-black group-hover:text-yellow-700"
                      }`}
                        >
                          <p dir="rtl" className="font-tajawal">
                            تواصل معنا
                          </p>
                          <IoCall />
                        </Link>
                        <span
                          className={`ease-in-out absolute bottom-0 h-2 rounded-t-full bg-yellow-700
                      duration-100 flex items-center justify-center ${
                        selectedMenu === "contactus"
                          ? "w-full"
                          : "group-hover:w-full w-0 "
                      }`}
                        ></span>
                      </motion.div>
                    </motion.div>
                  </motion.div>
                </LayoutGroup>
                {/* End-contactUs */}
              </motion.div>
              {/* search */}
              <motion.div
                layout
                className=" flex items-center justify-center mt-10"
              >
                <MobileSearch handleToggleNav={handleToggleNav} />
              </motion.div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MobileNav;
